import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	file: {
		list: {
			url: api(`/ly/drill/file`),
			name: "话术文档分页",
			get(params = {}) {
				return http.get(this.url, params);
			},
		},
		save: {
			url: api("/ly/drill/file/edit"),
			name: "编辑话术文档",
			post(data = {}) {
				return http.post(this.url, data);
			},
		},
		delete: {
			url(id) {
				return api(`/ly/drill/file/${id}`);
			},
			name: "删除话术文档",
			delete(id) {
				return http.delete(this.url(id));
			},
		},
		status: {
			url(id) {
				return api(`/ly/drill/file/${id}`);
			},
			name: "修改话术文档状态",
			put(id) {
				return http.put(this.url(id));
			},
		},
	},
};
